<template>
    <div class="page-container">
        <div class="order-page-header">
            <div class="order-page-header-left-badge-container">
                <img v-if="this.nodeHolerType === 'advanced'" class="community-badge" src="../images/badges/crown.svg"
                     alt="crown">
            </div>
            {{ localize('我的社群') }}
            <div class="order-page-header-badge-container">
                <img v-if="this.nodeHolerType === 'basic'" class="community-badge" src="../images/badges/diamond.svg"
                     alt="crown">
                <img v-if="isLeader" class="community-badge" src="../images/badges/star.svg" alt="crown">
                <img v-if="isLeader" class="community-badge" src="../images/badges/star.svg" alt="crown">
                <img v-if="isClub" class="community-badge" src="../images/badges/star.svg" alt="crown">
                <div v-if="this.communityLevel" class="community-badge">{{ this.communityLevel }}</div>
            </div>
        </div>
        <template v-if="this.refereeOrderList.length === 0">
            <div class="empty-order-container">
                <img class="empty-order-img" src="../images/empty.svg" alt="empty">
                <div class="empty-order-text">{{ localize('空') }}</div>
            </div>
        </template>
        <div v-if="this.refereeOrderList.length > 0" class="order-list-container">
            <div class="stats-container">
                <div class="community-stats-container">
                    <div class="stats-item">{{ localize('社群节点总地址 个：') + this.nodeRefereeCount }}</div>
                    <!--                    <div class="stats-item">{{localize('社群NFT总地址 个：') + this.nftRefereeCount}}</div>-->
                </div>

                <div class="community-stats-container">
                    <div class="stats-item">{{ localize('社群总业绩 U：') + `${this.totalAmount.toFixed(1)}` }}</div>
                    <div class="stats-item">{{ localize('NFT业绩 U：') + `${this.totalNftAmount.toFixed(1)}` }}</div>
                </div>

            </div>
            <template v-for="(item) in this.refereeOrderList" :key="item.tx">
                <div class="order-container" v-if="item.isConfirmed === true">
                    <div class="order-tx">{{ localize('转账哈希：') + this.getShortenHashTx(item.tx) }}</div>
                    <div class="order-tx">{{
                            localize('付款地址：') + this.getShortenWallet(item.purchaseWalletAddress)
                        }}
                    </div>
                    <div class="order-tx">{{ localize('節點類型：') + this.getNodeTypeTxt(item.purchaseNodeType) }}</div>
                    <div class="order-tx">{{ localize('金额：') + `${item.paymentAmount} USDT` }}</div>
                    <div class="order-time">{{ localize('创建时间：') + item.createTimeString }}</div>
                </div>
                <div v-else class="order-container-not-buy">
                    <div class="refer-wallet">{{
                            localize('推荐地址：') + this.getShortenWallet(item.walletAddress)
                        }}
                    </div>
                    <div class="refer-time">{{ localize('推荐时间：') + item.createTimeString }}</div>
                </div>
            </template>
            <template v-for="(item) in this.directRefereeNftOrders" :key="item.tx">
                <div class="nft-order-container" v-if="item.isConfirmed === true">
                    <div class="nft-order-tx">{{ localize('转账哈希：') + this.getShortenHashTx(item.tx) }}</div>
                    <div class="nft-order-tx">
                        {{ localize('付款地址：') + this.getShortenWallet(item.purchaseWalletAddress) }}
                    </div>
                    <div class="nft-order-tx">{{ localize('NFT类型：') + item.nftType }}</div>
                    <div class="nft-order-tx">{{ localize('金额：') + `${item.paymentAmount} USDT` }}</div>
                    <div class="nft-order-time">{{ localize('创建时间：') + item.createTimeString }}</div>
                </div>
                <div v-else class="order-container-not-buy">
                    <div class="refer-wallet">{{
                            localize('推荐地址：') + this.getShortenWallet(item.walletAddress)
                        }}
                    </div>
                    <div class="refer-time">{{ localize('推荐时间：') + item.createTimeString }}</div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import {postRequestAsync} from '@/utils/request'
import {showToast} from "@/utils/toastHelper";
import {hideLoading, showLoading} from "@/utils/spinnerHelper";
import {maskBscAddress, maskTxHash, toChecksumAddress} from "@/utils/web3Helper";

export default {
    name: 'CommunityPage',
    props: {
        msg: String
    },
    inject: ['langStore', 'localize'],
    data() {
        return {
            refereeOrderList: [],
            totalMember: 0,
            totalAmount: 0,
            totalNftAmount: 0,
            isLeader: false,
            isClub: false,
            communityLevel: null,
            nodeHolerType: null,
            nftRefereeCount: 0,
            nodeRefereeCount: 0,
            directRefereeNftOrders: []
        }
    },
    async mounted() {
        if (this.myWalletAddress) {
            await this.getMyRefereeOrders()
        }
    },
    watch: {
        async myWalletAddress(newVal, oldVal) {

            if (!newVal) return
            // 若地址没变（某些情况下重复提交相同值），可直接返回
            if (newVal === oldVal) return

            await this.getMyRefereeOrders()
        }
    },
    computed: {
        myWalletAddress() {
            if (window.location.href.includes('localhost')) {
                return '0x43af4394faD8164f16F5407761BD244A30f0259F'
            } else {
                return this.$store.state.connectedWallet
            }

        }
    },
    methods: {
        async getMyRefereeOrders() {
            if (!this.myWalletAddress) {
                showToast(this.localize('请连接钱包'))
                return
            }
            showLoading(this.localize('获取中'))


            try {
                const [
                    nodeRefereeResult,
                    nftRefereeResult,
                    referStatsResult,
                    userInfoResult
                ] = await Promise.all([
                    postRequestAsync('refer/getMyRefereeOrders', {
                        walletAddress: this.myWalletAddress
                    }),
                    postRequestAsync('refer/getMyNftCommunityOrders', {
                        walletAddress: this.myWalletAddress
                    }),
                    postRequestAsync('refer/getMyCommunityStats', {
                        walletAddress: this.myWalletAddress
                    }),
                    postRequestAsync('user/getUserInfo', {
                        wallet: this.myWalletAddress
                    })
                ])

                if (nodeRefereeResult?.code === 200 && Array.isArray(nodeRefereeResult?.msg?.refereeOrders) && Array.isArray(nodeRefereeResult?.msg?.referInfoRecords)) {
                    const notBuy = []
                    for (const item of nodeRefereeResult?.msg?.referInfoRecords) {
                        const order = nodeRefereeResult?.msg?.refereeOrders.find(referOrder => referOrder.purchaseWalletAddress === item.refereeWalletAddress)
                        if (!order) {
                            notBuy.push({
                                isConfirmed: false,
                                walletAddress: item.refereeWalletAddress,
                                createTimestamp: item.createTimestamp,
                                createTimeString: item.createTimeString,
                            })
                        }
                    }

                    const firstRefereeOrders = nodeRefereeResult?.msg?.refereeOrders.filter(x => x.isConfirmed === true && toChecksumAddress(x.referrerWalletAddress) === toChecksumAddress(this.myWalletAddress))

                    const all = [...notBuy, ...firstRefereeOrders]

                    this.totalMember = nodeRefereeResult?.msg?.refereeOrders.filter(x => x.isConfirmed === true).length;

                    this.totalAmount = nodeRefereeResult?.msg?.refereeOrders.reduce((acc, x) => {
                        if (x.isConfirmed === true) {
                            acc += Number(x.paymentAmount) || 0; // 将字符串数字转为数值，非法为 NaN 则当 0
                        }
                        return acc;
                    }, 0);

                    this.refereeOrderList = all
                }

                if (nftRefereeResult?.code === 200 && Array.isArray(nftRefereeResult?.msg?.nftCommunityRefereeOrders) && Array.isArray(nftRefereeResult?.msg?.nftDirectRefereeRecords)) {
                    this.totalNftAmount = 0
                    for (const item of nftRefereeResult?.msg?.nftCommunityRefereeOrders) {
                        this.totalNftAmount += item.count * item.paymentAmount
                    }
                    this.directRefereeNftOrders = []
                    for (const item of nftRefereeResult?.msg?.nftDirectRefereeRecords) {
                        this.directRefereeNftOrders.push({...item})
                    }
                }

                if (referStatsResult?.code === 200 && Array.isArray(referStatsResult?.msg?.stats) && referStatsResult?.msg?.stats.length > 0) {

                    this.nodeRefereeCount = referStatsResult?.msg?.stats?.length
                    // referStatsResult?.msg?.stats.forEach(item => {
                    //     if (item.isNftHolder === true) {
                    //         this.nftRefereeCount++
                    //     }
                    //     if (item.isNodeHolder === true) {
                    //         this.nodeRefereeCount++
                    //     }
                    // })
                }

                if (userInfoResult.code === 200) {
                    this.nodeHolerType = userInfoResult.msg.nodeType
                    this.isClub = !!userInfoResult.msg.isClub
                    this.isLeader = !!userInfoResult.msg.isLeader
                    this.communityLevel = userInfoResult.msg.level
                }
            } catch (e) {

            } finally {
                hideLoading()
            }
        },
        getNodeTypeTxt(type) {
            if (type === 'basic') {
                return this.localize("初級節點")
            }
            return this.localize("高級節點")
        },
        getShortenHashTx(tx) {
            return maskTxHash(tx)
        },
        getShortenWallet(address) {
            return maskBscAddress(address)
        },
    }
}
</script>
<style scoped>

.order-page-header {
    font-size: 2em;
    color: #38FF59;
    position: relative;
    width: 100%;
}

.order-page-header-badge-container {
    position: absolute;
    display: flex;
    flex-direction: row;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}

.order-page-header-left-badge-container {
    position: absolute;
    display: flex;
    flex-direction: row;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
}

.empty-order-img {
    width: 12em;
    padding: 1em;
    box-sizing: border-box;
}

.empty-order-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 1em;
    opacity: 0.5;
    padding: 3em;
    box-sizing: border-box;
}

.empty-order-text {
    font-size: 2em;
    color: #38FF59;
}

.nft-order-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 2px solid #b174c3;
    padding: 1em;
    box-sizing: border-box;
    border-radius: 0.4em;
    align-items: start;
    gap: 0.8em;
}

.order-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 2px solid #38FF59;
    padding: 1em;
    box-sizing: border-box;
    border-radius: 0.4em;
    align-items: start;
    gap: 0.8em;
}

.order-container-not-buy {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: 2px solid #a4b5a6;
    padding: 1em;
    box-sizing: border-box;
    border-radius: 0.4em;
    align-items: start;
    gap: 0.8em;
}

.order-time {
    font-size: 1.6em;
    color: #38FF59;
}

.nft-order-time {
    font-size: 1.6em;
    color: #b174c3;
}

.refer-wallet {
    font-size: 1.6em;
    color: #a4b5a6;
    width: 100%;
    overflow-x: hidden;
    word-wrap: break-word;
}

.refer-time {
    font-size: 1.6em;
    color: #a4b5a6;
}

.order-tx {
    font-size: 1.6em;
    color: #38FF59;
    width: 100%;
    overflow-x: hidden;
    word-wrap: break-word;
}

.nft-order-tx {
    font-size: 1.6em;
    color: #b174c3;
    width: 100%;
    overflow-x: hidden;
    word-wrap: break-word;
}

.order-list-container {
    width: 100%;
    padding: 1em 0;
    box-sizing: border-box;
    text-align: start;
    display: flex;
    flex-direction: column;
    gap: 1em;
}

.stats-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: start;
    background-color: rgba(56, 255, 89, 0.2);
    padding: 1em;
    box-sizing: border-box;
    font-size: 1em;
    border-radius: 0.2em;

}

.stats-item {
    font-size: 1.2em;
    color: #ffffff;
}

.community-stats-container {
    display: flex;
    flex-direction: column;
    align-items: end;
}

.community-badge {
    width: 0.9em;
    color: #FFFFFF;
    font-size: 0.8em;
}
</style>